// extracted by css-extract-rspack-plugin
export default {"connectionHeaderContainer":"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__connectionHeaderContainer-_kxKxX","circlesContainer":"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__circlesContainer-vJXbXM","deviceContainer":"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__deviceContainer-lfFqDr","circlesWrapper":"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__circlesWrapper-rJYBgB"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"connectionHeaderContainer\":\"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__connectionHeaderContainer-_kxKxX\",\"circlesContainer\":\"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__circlesContainer-vJXbXM\",\"deviceContainer\":\"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__deviceContainer-lfFqDr\",\"circlesWrapper\":\"src-domain-components-tem-connection-modal-header-temConnectionModalHeader-module__circlesWrapper-rJYBgB\"}";
        // 1792611263351
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  